/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["COMPLETED"] = "Completed";
    TaskStatus["NOT_COMPLETED"] = "Not Completed";
})(TaskStatus || (TaskStatus = {}));
